var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["header/partials/bhldn.j2"] = require( "header/partials/bhldn.j2" );
dependencies["header/partials/terrain.j2"] = require( "header/partials/terrain.j2" );
dependencies["header/utility-registry.j2"] = require( "header/utility-registry.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/brand-navigation.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"userLocation")),"isUS") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"isSiteOutsideUSA")) {
output += "<div class=\"c-brand-navigation\">\n\n    <ul class=\"c-brand-navigation__list\">\n\n\n        <li class=\"c-brand-navigation__list-item\">\n\n            ";
env.getTemplate("header/partials/bhldn.j2", false, "core/templates/header/brand-navigation.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n        </li>\n\n        <li class=\"c-brand-navigation__list-item\">\n\n            ";
env.getTemplate("header/partials/terrain.j2", false, "core/templates/header/brand-navigation.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n        </li>\n\n\n        <li class=\"c-brand-navigation__list-item\">\n\n            ";
env.getTemplate("header/utility-registry.j2", false, "core/templates/header/brand-navigation.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n        </li>\n\n    </ul>\n\n</div>";
})})})})})});
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/brand-navigation.j2"] , dependencies)